module.exports = __webpack_public_path__ + "static/media/message.16bca625.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/vectors/message.svg
// module id = 219
// module chunks = 0